export default "__VITE_ASSET__DrNzfNuY__"